"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class JsonLogFormat {
    constructor(pretty) {
        this.pretty = false;
        this.pretty = pretty;
    }
    format(msg, metadata) {
        const logMsgObj = Object.assign({}, metadata, msg);
        if (this.pretty) {
            return JSON.stringify(logMsgObj, undefined, 2) + "\n"; // each message is split by an empty line
        }
        else {
            return JSON.stringify(logMsgObj);
        }
    }
    getName() {
        return this.pretty ? JsonLogFormat.FORMAT_NAME_PRETTY : JsonLogFormat.FORMAT_NAME;
    }
}
JsonLogFormat.FORMAT_NAME = "json";
JsonLogFormat.FORMAT_NAME_PRETTY = "json_pretty";
exports.JsonLogFormat = JsonLogFormat;
//# sourceMappingURL=JsonLogFormat.js.map